import { useParams } from "react-router";
import OrbButton from "../../../../shared/components/orb-button";
import { Controller, useForm } from "react-hook-form";

import OrbInput from "../../../../shared/forms/orb-input";
import { useMutation } from "@tanstack/react-query";
import authService from "../../services/auth-service";

import { authConfig, registerConfig } from "../../auth-config";
import { yupResolver } from "@hookform/resolvers/yup";
import { registerValidationSchema } from "../../../../shared/components/schema-validation/schema-validation";
import { useCallback, useEffect, useMemo } from "react";
import { debounce } from "@mui/material";
import { useTranslation } from "react-i18next";
import { registerInputProps, registerProps } from "../../auth-interface";

const Register = (props: registerProps) => {
  const { setSelectedDetails, save, registerLoading } = props;
  const { encryptData } = useParams();
  const { t } = useTranslation();
  const defaultValues = {
    usr_fname: "",
    usr_lname: "",
    usr_phone: "",
    usr_email: "",
    usr_password: "",
    confirmPassword: "",
    usr_type: 2,
    usr_status: 1,
    cy_status: 1,
    orb_status: 1,
    ...(encryptData && { encrypt: encryptData } ),
  };
  const {
    control,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues,
    resolver: yupResolver(registerValidationSchema),
  });

  const handleRegisterOpen = () => {
    setSelectedDetails(authConfig.login);
  };

  const onValuechange = (name: any, value: any) => {
    if (name === "usr_email") {
      onChangeEmailValue(value);
    }
  };
  const onChangeEmailValue = useCallback(
    debounce((value: string) => {
      if (value) {
        emailValidation({ email: value });
      }
    }, 500),
    []
  );

  const { mutate: emailValidation } = useMutation({
    mutationFn: authService.emailValidation,
    onSuccess(data, variables, context) {
      if (data.data.status === "error") {
        setError("usr_email", {
          type: "manual",
          message: data?.data?.message,
        });
      }
    },
  });

  const onSubmit = (formValue: any) => {
    const payload = { ...formValue };
    delete payload.confirmPassword;
    onChangeEmailValue(payload.usr_email);
    save(payload, authConfig.register.id);
  };
 useEffect(() => {
    if (encryptData) {
      setSelectedDetails(authConfig.register);
    }
  }, [encryptData]);
  


  const InputField = useMemo(
    () => (props: registerInputProps) => {
      const { name, type, placeholder, errorMessage, label } = props;

      return (
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <OrbInput
              type={type}
              placeholder={t(placeholder)}
              value={value}
              onChange={(e: any) => {
                const newValue = e.target.value;
                onChange(newValue);
                onValuechange(name, newValue);
              }}
              errorMessage={t(errorMessage)}
              label={t(label)}
            />
          )}
        />
      );
    },
    [control, onChangeEmailValue]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <div className="row">
        {registerConfig().map((data: any) => {
          return (
            <div className={data.style}>
              <InputField
                name={data.name}
                type={data.type}
                placeholder={data.placeholder}
                label={data.label}
                errorMessage={errors?.[data.name]?.message ?? ""}
              />
            </div>
          );
        })}

        <div>
          <p className="mt-4 mohave sub-font m-1">
            {t("already_have_an_account?")}{" "}
            <span className="text-info pointer" onClick={handleRegisterOpen}>
              {t("log_in")}
            </span>
          </p>
        </div>

        <div className={` mt-3 d-flex justify-content-end `}>
          <OrbButton
            type={"submit"}
            className={" mohave "}
            size={""}
            label={t("ready")!}
            loading={registerLoading}
          />
        </div>
      </div>
    </form>
  );
};

export default Register;
